<template>
  <div
    :class="[
      'mega-cele',
      {
        plr16: extraPadding === 'true',
        'btn-full': imgData?.length === 0,
      },
    ]"
    :style="[isLast && { 'margin-bottom': '80px' }]"
  >
    <div class="mb16" v-if="title">
      <div class="title">{{ title }}</div>
      <div v-if="subTitle" class="subTitle">{{ subTitle }}</div>
    </div>
    <div
      v-for="(item, index) in imgData"
      :key="index"
      class=""
      :class="[
        'wrap',
        {
          plr16: item.extraPadding,
          mb40: !item.removeBottomMargin,
        },
      ]"
    >
      <lazy-image
        class=""
        alt="image"
        :src="item.image"
        :src-placeholder="getPlaceHolderImg"
        :intersection-options="{ threshold: 0.1 }"
      />
    </div>
    <div v-if="isBtn" class="pTB20 plr16">
      <div class="fs-14 btn bold" @click="goto">{{ isBtn }}</div>
    </div>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>
<script>
import {
  projectBasePathWithFolder,
  staticImgBaseUrl,
} from "../config/apiEndpoints";
import { keyMapsGetter } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import localStorageFunc from "../helpers/localStorageFunc";

export default {
  name: "FullImageCard",
  props: ["moduleProps"],
  components: {},
  data: () => ({
    modulePropsData: {},
    imgData: [],
    extraPadding: false,
    title: "",
    subTitle: "",
    type: "",
    isBtn: "",
    isLast: false,
    assetName: "",
  }),
  mounted() {
    this.modulePropsData =
      this.moduleProps != null &&
      this.moduleProps != "null" &&
      this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.title = this.modulePropsData?.title || "";
    this.subTitle = this.modulePropsData?.subTitle || "";
    this.type = this.modulePropsData?.type || "";
    this.isBtn = this.modulePropsData?.btn || "";
    this.isLast = this.modulePropsData?.isLast == "true" || false;

    const { imageUrls = "", extraPadding = false } = this.modulePropsData;
    if (imageUrls) {
      this.imgData = JSON.parse(imageUrls);
    }

    this.extraPadding = extraPadding;

    let queryParams = Utility.getQueryFromUrl();
    this.assetName = queryParams["fromApp"];
  },
  methods: {
    goto() {
      let url =
        projectBasePathWithFolder +
        Utility.getMenuCategory() +
        localStorageFunc.storeId() +
        Utility.getUrlQueryString();
      url = Utility.addUpdateParam(url, "showSearchModal", false);
      url = Utility.addUpdateParam(url, "scrollTo", "menuTop");

      const actionData = {
        links: [
          {
            title: "Mega Milestone",
            href: "2",
            action: "menu",
            closeScreen: "false",
          },
        ],
      };

      this.redirectPage(url , actionData);
      // // For Android
      // if (window.Android) {
      //   window.Android.sendClickEvent(JSON.stringify(actionData));
      // }
      // // For iOS
      // if (
      //   window.webkit &&
      //   window.webkit.messageHandlers &&
      //   window.webkit.messageHandlers.iOS
      // ) {
      //   gamifyActions[postMessage](actionData);
      //   window.webkit.messageHandlers.iOS.postMessage(
      //     JSON.stringify(actionData)
      //   );
      // } else {
      //   window.location.href = url;
      // }
    },
    redirectPage(url , actionData){
      let assetPrefix;
      if (this.assetName === "ios") {
        assetPrefix = window.webkit.messageHandlers;
      } else if (this.assetName === "android") {
        assetPrefix = window.Android;
      }

      if (this.assetName === "ios") {
        const methodPrefix = assetPrefix["gamifyActions"];
        return methodPrefix["postMessage"](actionData);
      } else if (this.assetName === "android") {
        return window.Android["gamifyActions"](JSON.stringify(actionData));
      } else {
        window.location.href = url;
      }
    }
  },
  computed: {
    getPlaceHolderImg() {
      const img =
        this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.square;
      const fallBack =
        staticImgBaseUrl + "/images/global/default-product-img-lg.png";
      return img || fallBack;
    },
  },
};
</script>
